// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"551":"b175e5cf","640":"e55e6262","760":"b209591e","842":"d2a1c63f"}[chunkId] + ".chunk.js";
};